import React from "react";
import {useField} from "formik";
import {FieldFeedbackLabel} from "./FieldFeedbackLabel";
import ReactSelect from "react-select"

const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control", "form-control-solid"];
  if (touched && errors) {
    classes.push("is-invalid-select");
  }

  if (touched && !errors) {
    classes.push("is-valid-select");
  }

  return classes.join(" ");
};

const getSearchFieldCSSClasses = (touched, errors) => {
  const classes = [];
  if (touched && errors) {
    classes.push("is-invalid-select");
  }

  if (touched && !errors) {
    classes.push("is-valid-select");
  }

  return classes.join(" ");
};

export function Select({
  label,
  withFeedbackLabel = true,
  type = "text",
  customFeedbackLabel,
  children,
  ...props
}) {
  const [field, meta] = useField(props);
  const { touched, error } = meta;
  return (
    <>
      {label && <label>Select {label}</label>}
      <select
        className={getFieldCSSClasses(touched, error)}
        {...field}
        {...props}
      >
        {children}
      </select>
      {withFeedbackLabel && (
        <FieldFeedbackLabel
          erros={error}
          touched={touched}
          label={label}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
    </>
  );
}

export function SearchSelect({
  label,
  withFeedbackLabel = true,
  type = "text",
  customFeedbackLabel,
  children,
  options,
  changePriceField, 
  changeState,
  ...props
}) {
  const [field, meta, form] = useField(props);
  const { touched, error } = meta;

  const getValue = () => {
    if (options) {
      return options.find(option => option.value === field.value);
    } else {
      return "";
    }
  };

 const onChange = (option) => {
    form.setValue(  
      option.value
    );
    if(changePriceField) changePriceField(option.value);
    if(changeState) changeState(option.value);
  };

  return (
    <>
      {label && <label>Select {label}</label>}
      <ReactSelect
        isSearchable
        value={getValue()}
        onChange={onChange}
        options={options}
        className={getSearchFieldCSSClasses(touched, error)}
        {...props}
      />
      {withFeedbackLabel && (
        <FieldFeedbackLabel
          erros={error}
          touched={touched}
          label={label}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
    </>
  );
}
